const testimonials = [
  {
    name: "Jessica M.",
    location: "Key Largo, FL",
    rating: 5,
    text: "I'm a dive instructor at a Key Largo shop and lead groups to Cozumel twice a year. Six days before our winter trip, I pulled my passport and it had expired three months ago. Fast Passport Center had my renewal processed and delivered in four business days. I made the trip, led my group through the Palancar Reef, and we had an incredible week. Their team understood dive travel deadlines better than anyone.",
    service: "Passport Renewal",
  },
  {
    name: "David & Karen H.",
    location: "Key Largo, FL",
    rating: 5,
    text: "We've owned a waterfront home in Key Largo for twelve years and travel to the Bahamas every winter for liveaboard diving. This year we booked a ten-day Exuma Cays trip and discovered Karen's passport had expired. We had nine days until the boat departed Miami. Fast Passport Center got her renewal done in five business days. We made the liveaboard, dove the Cat Island hammerhead site, and never missed a single day. They saved our annual tradition.",
    service: "Passport Renewal",
  },
  {
    name: "Dr. Amanda S.",
    location: "Key Largo, FL",
    rating: 5,
    text: "I'm a marine biologist based at a research station in Key Largo who was scheduled for a coral restoration project in Bimini. Two weeks before departure, I realized my passport was within the six-month validity window and the Bahamas would not admit me. Fast Passport Center expedited my renewal in six business days. I made the research trip, contributed to the coral outplanting project, and maintained my grant timeline. Professional, fast, and they understood scientific travel requirements.",
    service: "Expedited Renewal",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function KeyLargoTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Key Largo Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Key Largo divers, marine biologists, instructors, and families who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}